module.exports = __webpack_public_path__ + "img/big_ico_app@3x.fa8e1058.png";